<template>
    <div
        v-if="( !visitor && whatsapp.student_status) || ( visitor && whatsapp.visitor_status)" 
        class="fabs"
        :style="hasChat ? 'right: 70px' : 'right: 0px'"
    >
        <a id="wpp" class="fab" :href="visitor ? whatsapp.visitor_url : whatsapp.student_url" target="_blank">
            <i class="fab fa-whatsapp"></i>
        </a>
    </div>
</template>
<script>

export default {
    name: 'WhatsAppLink',
    props: {
        whatsapp: Object,
        visitor: Boolean,
        hasChat: [Boolean, Number],
    }
}
</script>

<style scoped>
.fabs{
    bottom: 0;
    position: fixed;
    margin: 1em;
    z-index: 996;
}
.fab{
    display: block;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    text-align: center;
    color: #f0f0f0;
    margin: 0 auto;
    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
    cursor: pointer;
    -webkit-transition: all 0.1s ease-out;
    transition: all 0.1s ease-out;
    position: relative;
    z-index: 996;
    overflow: hidden;
    background: rgb(89,211,101);
}
.fab > i{
    color: white;
    font-size: 2em;
    line-height: 55px;
    -webkit-transition: all 0.2s ease-out;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}
.fab:hover > i{
    transform: scale(1.1);
}
</style>
